// import './App.css';
import LandingPage from './components/pages/landingPage/LandingPage';

function App() {
  return (
    <div className="App">
     <LandingPage/>
    </div>
  );
}

export default App;
